import { Component, OnInit, TemplateRef } from '@angular/core';
import { UlthreedmarkService } from '../../../modules/details-page/services/ulthreedmark/ulthreedmark.service';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';

@Component({
  selector: 'app-ulthreedmark',
  templateUrl: './ulthreedmark.component.html',
  styleUrls: ['./ulthreedmark.component.scss']
})
export class UlthreedmarkComponent implements OnInit {
  private modalOption: NgbModalOptions = {}
  ulThreeDMarkData: any;
  ulThreeSubTitle: any;
  isPantherLakeStd: boolean = false;
  isPantherLake12Xe: boolean = false;
  isPantherLakeGaming: boolean = false;
  setFontIntelDisplayOne = false;
   averageScoreText: string = '';
  fpsSettingText: string = '';
  fpsResolution: string = '';
  fpsData: any[] = [];  
  games: any;
  currentIndex: number = 0;
  nonItalicLangArray = ['ar-sa','he','ja','ko','th','zh-cn','zh-tw'];
  language: string;
  private touchStartX: number = 0;
  private touchStartY: number = 0;
  private touchEndX: number = 0;
  private touchEndY: number = 0;
  private minSwipeDistance: number = 50;

  constructor(
    private ulthreedmarkService: UlthreedmarkService,
    private qrCodeService: QrCodeService,
    private modalService: NgbModal,
    private libraryService: LibraryV2DataService
  ) { }

  ngOnInit(): void {
    this.ulThreeDMarkData = this.ulthreedmarkService.getULThreeDMarkData();
    this.isPantherLakeStd = this.qrCodeService.isPantherLakeStd;
    this.isPantherLake12Xe = this.qrCodeService.isPantherLake12Xe;
    this.isPantherLakeGaming = this.qrCodeService.isPantherLakeGaming;
    this.setFontIntelDisplayOne = this.qrCodeService.setenusLang();
    this.averageScoreText = this.libraryService.getStaticText("tr_average_fps");
    this.fpsSettingText = this.libraryService.getStaticText("tr_fps_setting");
    this.fpsResolution = this.libraryService.getStaticText("tr_fps_resolution");
    this.games = this.libraryService.getStaticText("tr_ulthreedGames");    
    this.fpsData = this.ulthreedmarkService.getFpsData();
    if(this.fpsData){
    this.fpsData = this.fpsData.filter(game => this.games.some(gamededata => (game.name === gamededata.game_demo_name && game.score > 0 && game.score !== null)));    
      this.addTargetUrlToDeGames();
    }
    const qrData = this.qrCodeService?.getQrData();
    this.language = qrData.Language;
  }
  openFPSGamingLegalModal(legalModal: TemplateRef<any>) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.centered = true;
    this.modalOption.windowClass = 'ptl-gaming-legal-and-disclamiers-popup fps-modalpopup'
    this.modalService.open(legalModal, this.modalOption);
  }
  closePTLGamingLegalModal() {
    this.modalService.dismissAll()
  }
  getCardPosition(index: number): number {
    const totalCards = this.fpsData.length;
    let diff = index - this.currentIndex;
    
    // Handle circular wrapping
    if (diff > totalCards / 2) {
      diff -= totalCards;
    } else if (diff < -totalCards / 2) {
      diff += totalCards;
    }    
    return diff;
  }

  goToSlide(index: number): void {
    this.currentIndex = index;
  }

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;
  }

  onTouchEnd(event: TouchEvent): void {
    this.touchEndX = event.changedTouches[0].screenX;
    this.touchEndY = event.changedTouches[0].screenY;
    this.handleSwipe();
  }

  private handleSwipe(): void {
    const swipeX = this.touchStartX - this.touchEndX;
    const swipeY = this.touchStartY - this.touchEndY;

    if (Math.abs(swipeX) <= Math.abs(swipeY)) return;

    if (Math.abs(swipeX) > this.minSwipeDistance) {
      if (swipeX > 0) {        
        this.currentIndex = (this.currentIndex + 1) % this.fpsData.length;
      } else {
        this.currentIndex = (this.currentIndex - 1 + this.fpsData.length) % this.fpsData.length;
      }
    }
  }

  addTargetUrlToDeGames() {
    this.fpsData.forEach(fpsGame => {
      let targetUrl = this.games.find(game => game.game_demo_name === fpsGame.name).targetUrl;
      fpsGame['targetUrl'] = targetUrl;
    });
}

setFont(){
  return this.qrCodeService.setFont();
}
}
